{
  "CANNED_MGMT": {
    "HEADER": "Готови отговори",
    "LEARN_MORE": "Learn more about canned responses",
    "DESCRIPTION": "Canned Responses are pre-written reply templates that help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a canned response during a conversation. ",
    "HEADER_BTN_TXT": "Add canned response",
    "LOADING": "Fetching canned responses...",
    "SEARCH_404": "Няма резултати отговарящи на тази заявка.",
    "LIST": {
      "404": "Няма налични готови отговори в този акаунт.",
      "TITLE": "Управлявайте готовите отговори",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Short code",
        "CONTENT": "Съдържание",
        "INBOXES": "Кутии",
        "ACTIONS": "Действия"
      },
      "ALL_INBOXES": "Всички кутии",
      "FILTER": {
        "ALL_INBOXES": "Всички кутии",
        "NO_INBOX": "Без кутия",
        "SEARCH_PLACEHOLDER": "Търсене на кутии"
      }
    },
    "ADD": {
      "TITLE": "Add canned response",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "CANCEL_BUTTON_TEXT": "Отмени",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a short code.",
          "ERROR": "Short Code is required."
        },
        "SUBJECT": {
          "LABEL": "Тема (само за имейл)",
          "PLACEHOLDER": "Незадължителна тема за имейл отговори / нови разговори"
        },
        "CONTENT": {
          "LABEL": "Съобщение",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Message is required."
        },
        "ATTACHMENTS": {
          "LABEL": "Прикачени файлове"
        },
        "INBOXES": {
          "LABEL": "Кутии",
          "PLACEHOLDER": "Изберете кутии (по избор, оставете празно за всички кутии)"
        },
        "SUBMIT": "Изпращане"
      },
      "API": {
        "SUCCESS_MESSAGE": "Canned response added successfully.",
        "ERROR_MESSAGE": "Не можа да се свърже с Woot сървър. Моля, опитайте отново по-късно"
      }
    },
    "EDIT": {
      "TITLE": "Edit canned response",
      "CANCEL_BUTTON_TEXT": "Отмени",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a shortcode.",
          "ERROR": "Short code is required."
        },
        "SUBJECT": {
          "LABEL": "Тема (само за имейл)",
          "PLACEHOLDER": "Незадължителна тема за имейл отговори / нови разговори"
        },
        "CONTENT": {
          "LABEL": "Съобщение",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Message is required."
        },
        "ATTACHMENTS": {
          "LABEL": "Прикачени файлове"
        },
        "INBOXES": {
          "LABEL": "Кутии",
          "PLACEHOLDER": "Изберете кутии (по избор, оставете празно за всички кутии)"
        },
        "SUBMIT": "Изпращане"
      },
      "BUTTON_TEXT": "Редактирай",
      "API": {
        "SUCCESS_MESSAGE": "Canned response is updated successfully.",
        "ERROR_MESSAGE": "Не можа да се свърже с Woot сървър. Моля, опитайте отново по-късно"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Изтрий",
      "API": {
        "SUCCESS_MESSAGE": "Canned response deleted successfully.",
        "ERROR_MESSAGE": "Не можа да се свърже с Woot сървър. Моля, опитайте отново по-късно"
      },
      "CONFIRM": {
        "TITLE": "Потвърди изтриването",
        "MESSAGE": "Сигурни ли сте за изтриването ",
        "YES": "Yes, delete ",
        "NO": "No, keep "
      }
    }
  }
}
